<p-table [value]="triggers()">
  <ng-template pTemplate="header">
    <tr>
      <th>{{ 'core.jobAdmin.triggerTable.name' | translate }}</th>
      <th>{{ 'core.jobAdmin.triggerTable.group' | translate }}</th>
      <th>{{ 'core.jobAdmin.triggerTable.status' | translate }}</th>
      <th>{{ 'core.jobAdmin.triggerTable.nextFireTime' | translate }}</th>
      <th>{{ 'core.jobAdmin.triggerTable.previousFireTime' | translate }}</th>
      <th>{{ 'core.jobAdmin.triggerTable.actions' | translate }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-trigger>
    <tr>
      <td>{{ trigger.key?.name }}</td>
      <td>{{ trigger.key?.group }}</td>
      <td><app-trigger-state-badge [state]="trigger.triggerState"></app-trigger-state-badge></td>
      <td>{{ trigger.nextFireTime | formatFutureRelativeTime }}</td>
      <td>{{ trigger.previousFireTime ? (trigger.previousFireTime | date:'dd.MM.yyyy HH:mm') : '–' }}</td>
      <td>
        @for (command of trigger.commands; track command.name) {
          <nx-default-button
            class="mr-1"
            [style]="'light'"
            [label]="command.settings?.label"
            [disabled]="command.settings?.disabled"
            (click)="onCommand(trigger, command)">
          </nx-default-button>
        }
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6" class="emptyMessage">{{ 'core.jobAdmin.triggerTable.emptyMessage' | translate }}</td>
    </tr>
  </ng-template>
</p-table>
